import Box from '@eversports/klimt-primitives/legacy/Box'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import { visuallyHidden } from '@eversports/klimt-utilities/visually-hidden'
import * as React from 'react'

import { Localized } from '../localization/react'

import { CheckboxVariant } from './FilterCheckbox'

interface Props {
  children: React.ReactNode
  variant?: CheckboxVariant
}

function FilterFieldsetWrapper({ children, variant }: Props) {
  return (
    <Stack component="fieldset" spacing={variant === 'drawer' ? 0 : 2}>
      <Box component="legend" sx={visuallyHidden}>
        <Localized id="filter-options" />
      </Box>
      {children}
    </Stack>
  )
}

export { FilterFieldsetWrapper }
